import { useEffect } from 'react';

function CoreRoute({ title, children }) {
  useEffect(() => {
    if (title) {
      document.title = `${title} | Javelin`;
    }
  }, [title]);

  return children;
}
export default CoreRoute;
